import React, { useState } from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import { renderBlocks } from '../components/renderBlocks'; // ✅ Shared rendering

export default function StepperQA({ items }) {
  const [stepIndex, setStepIndex] = useState(0);

  const handleNext = () => {
    if (stepIndex < items.length - 1) {
      setStepIndex(stepIndex + 1);
    }
  };

  const handlePrev = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1);
    }
  };

  const currentItem = items[stepIndex];

  return (
    <MathJaxContext>
      <div className="bg-white p-6 rounded shadow-md text-gray-800 max-w-3xl mx-auto">
        <div className="mb-4 text-center text-sm text-gray-500">
          Step {stepIndex + 1} of {items.length}
        </div>

        <div className="mb-4">
          <h3 className="font-semibold text-indigo-700">
            Q{currentItem.order_index}
          </h3>
          <div className="mt-2">
            {currentItem.question_blocks
              ? renderBlocks(currentItem.question_blocks)
              : renderBlocks([{ type: 'text', value: currentItem.question }])
            }
          </div>
        </div>

        <div className="mt-4 border-t pt-4">
          <p className="font-semibold text-gray-700 mb-2">Answer:</p>
          <div>
            {currentItem.answer_blocks
              ? renderBlocks(currentItem.answer_blocks)
              : renderBlocks([{ type: 'text', value: currentItem.answer }])
            }
          </div>

          {currentItem.hint && (
            <p className="mt-2 text-sm text-gray-500">
              💡 <strong>Hint:</strong> {currentItem.hint}
            </p>
          )}
        </div>

        <div className="mt-6 flex justify-between">
          <button
            onClick={handlePrev}
            disabled={stepIndex === 0}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300"
          >
            Previous
          </button>
          <button
            onClick={handleNext}
            disabled={stepIndex === items.length - 1}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </MathJaxContext>
  );
}
